import httpService from "./http.service";

class BrandsService {
    getBrandsUrl = "/brands";
    //   brandsAC = "/brand/ac";

    getBrands = (query) => {
        return httpService.get(`/brands?${query}`);
    };
    getAllBrands = () => {
        return httpService.get(`/brands/all`);
    };
    createBrand = (model) => {
        return httpService.form("/brands", model, "createBrand");
    };
    editBrand = (id, model) => {
        return httpService.form("/brands/" + id, model, "editBrand", {}, "patch");
    };
    deleteBrand = (id) => {
        return httpService.delete("/brands/" + id);
    };
    seoBrand = (id, model) => {
        return httpService.patch("/brands/seo/" + id, model, "seoBrand");
    };
}

const brandsService = new BrandsService();
export default brandsService;